const files = (state = [], action) =>
{
	switch (action.type)
	{
		case 'ADD_FILE':
		{
			const { roomFile } = action.payload;

			const newFile = {
				progress: 0,
				...roomFile
			};

			return [ ...state, newFile ];
		}

		case 'SET_FILE_HISTORY':
			return action.payload.fileHistory.map((el) => ({ ...el, progress: 0 }));
		case 'SET_FILE_PROGRESS':
		{
			const { filepath, progress } = action.payload;
			const fileIndex = state.findIndex((el) => el.filepath === filepath);

			if (fileIndex > -1)
			{
				state[fileIndex] = { ...state[fileIndex], progress };
			}

			return state;
		}

		case 'DELETE_FILE':
			return state.filter((el) => el.id !== action.payload.id);
		case 'CLEAR_FILES':
			return [];

		default:
			return state;
	}
};

export default files;
